<template>
    <div class="side-box">
        <v-layout justify-space-between align-center class="side-box-header">
            <div class="side-box-title">{{$t('ticketManagement')|capitalize}}</div>
            <v-icon @click="toggleTicket">mdi-close</v-icon>
        </v-layout>
        <div class="side-box-content side-box-session-info-list sidebar-full-height">
            <v-expansion-panel
                    v-model="panel"
                    expand
            >
                <v-expansion-panel-content
                        v-for="(item, i) in tickets"
                        :key="i"
                        expand-icon
                >
                    <template v-slot:header>
                        <div>
                            <ul>
                                <li class="header-panel">
                                    <span class="label">{{$t('status')|capitalize}}: </span>
                                    <div class="status-box mx-2" v-if="item.status==='0'">Opening</div>
                                    <div class="status-box" style="background: #B2B4C6" v-else>Closed</div>
                                </li>
                                <li class="header-panel" style="white-space: pre-wrap">
                                    <span class="label" style="min-width: 60px">{{$t('title')|capitalize}}: </span>
                                    <span style="word-break: break-word">{{item.title}}</span>
                                </li>
                                <li class="header-panel">
                                    <span class="label mr-2">{{$t('createdAt')|capitalize}}: </span>
                                    {{item.created_time | moment("DD/MM/YYYY HH:mm")}}
                                </li>
                                <li class="header-panel" v-if="item.closed_by">
                                    <span class="label mr-2">{{$t('closedBy')|capitalize}}: </span>
                                    {{item.closed_by.email}}
                                </li>
                            </ul>
                        </div>
                    </template>
                    <v-card flat>
                        <v-card-text>
                            <v-layout wrap>
                                <v-flex xs12 style="padding: 6px 0px">
                                    <span class="label">{{$t('supportRequest')|capitalize}}</span>
                                </v-flex>
                                <v-flex xs12>
                                    <div class="support-request" v-html="item.support_request" v-linkified>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn flat outline small color="#0052CC" @click="closeTicket(item)"
                                   :disabled="item.status==='1'">{{$t('closeTicket')|capitalize}}
                            </v-btn>
                            <v-spacer></v-spacer>
                            <a href="#" @click="openConversationHistoryByChatLog(item['conversation_history'])" v-if="item['include_conversation']">
                                <img style="position: relative;top: 5px;"
                                     src="/assets/icons/platform/conversation_history.svg"/>
                                <span style="padding: 0px 8px">{{$t('conversationHistory')|capitalize}}</span>
                            </a>
                        </v-card-actions>
                    </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </div>
    </div>
</template>
<script>
import {mapActions, mapMutations, mapState} from "vuex";

export default {
        name: "TicketManagement",
        data() {
            return {
                panel: [],
            }
        },
        computed: {
            ...mapState('ticket', ['tickets']),
        },
        mounted() {
            this.fetchTickets()
        },
        methods: {
            ...mapActions('ticket', ['getTickets', 'closeTicket']),
            ...mapMutations('sideBox', ['toggleTicket']),
            ...mapActions('dialog', ['openConversationHistoryByChatLog']),
            fetchTickets() {
                let botCode = this.$route.params.bot_code;
                let senderId = this.$route.params.senderId;
                this.getTickets({botCode, senderId})
            },
        },
    }
</script>
<style scoped lang="scss" src="@/components/style/side-box.scss"></style>
<style scoped lang="scss" src="@/components/style/staff.scss"></style>
<style scoped lang="scss" src="@/components/style/ticket-side-box.scss"></style>
